import { connectedComponent } from 'utils/redux/providerWrapper';
import Login from './login';

export const ConnectedLogin = connectedComponent(Login);

export default ConnectedLogin;
